import Activities from './activities.html';
export default class ActivitiesHandler {   
  get route() {      
    return {
      beforeenter: function ( route ) { 
    
      },  
      enter(current, previous) { 
        this.component = new Activities({
          target: document.getElementById('app'),
          store
        })
        //console.log('Entered activities!');
      },
      leave(current, previous) {
        this.component.destroy();
        //console.log('Left activities!');
      }
    }
  }
}